import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // @ts-expect-error No types given for file

import { AuthTypePropType } from '../../TryIt/constants'; // @ts-expect-error No types given for file

import { Operation } from '../../../lib/api-explorer/models/Oas'; // @ts-expect-error No types given for file

import { RATE_LIMIT_DOCUMENTATION } from '../constants/urls'; // @ts-expect-error No types given for file

import { getHasScopeSplitAccess } from '../../Auth/selectors';
import { getHasSplitScopesInSpec, getLegacyScopes, getGranularScopes, getSecurityTypes // @ts-expect-error No types given for file
} from '../selectors/DocSelectors'; // @ts-expect-error No types given for file

import { renderAuthTypes } from '../utils/DocsUtils'; // @ts-expect-error No types given for file

import ScopesCollection from './ScopesCollection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UILink from 'UIComponents/link/UILink'; // @ts-expect-error No types given for file

import Requirement from '../../../components/endpoint/Requirement';

const Requirements = ({
  operation,
  hasScopeSplitAccess,
  hasSplitScopesInSpec,
  granularScopes,
  legacyScopes,
  securityTypes
}) => {
  const renderRateLimit = () => {
    const rateLimit = operation['x-hubspot-rate-limit-exemptions'];
    let i18nKey;

    if (!rateLimit || !Array.isArray(rateLimit)) {
      i18nKey = 'standard';
    } else if (rateLimit.length === 2) {
      i18nKey = 'both';
    } else {
      i18nKey = rateLimit[0];
    }

    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `developer-docs-shared-components.requirements.limits.${i18nKey}_jsx`,
      options: {
        href: RATE_LIMIT_DOCUMENTATION,
        external: true
      },
      elements: {
        Link: UILink
      }
    });
  };

  const renderLegacyScopeHeaderText = () => {
    if (hasScopeSplitAccess && hasSplitScopesInSpec) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.requirements.scopes.header.standardScopes"
      });
    }

    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-shared-components.requirements.scopes.header.scopes"
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "m-bottom-6",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.requirements.header"
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      gap: 15,
      direction: "column",
      children: [/*#__PURE__*/_jsx(Requirement, {
        header: renderLegacyScopeHeaderText(),
        value: /*#__PURE__*/_jsx(ScopesCollection, {
          scopesCollection: legacyScopes
        })
      }), hasScopeSplitAccess && hasSplitScopesInSpec && /*#__PURE__*/_jsx(Requirement, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.scopes.header.granularScopes"
        }),
        value: /*#__PURE__*/_jsx(ScopesCollection, {
          scopesCollection: granularScopes
        })
      }), /*#__PURE__*/_jsx(Requirement, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.limits.header"
        }),
        value: renderRateLimit()
      }), /*#__PURE__*/_jsx(Requirement, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.authMethods.header"
        }),
        value: renderAuthTypes(securityTypes)
      })]
    })]
  });
};

Requirements.propTypes = {
  doc: PropTypes.shape({
    _id: PropTypes.string.isRequired
  }),
  hasScopeSplitAccess: PropTypes.bool.isRequired,
  hasSplitScopesInSpec: PropTypes.bool.isRequired,
  operation: PropTypes.instanceOf(Operation).isRequired,
  granularScopes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  securityTypes: PropTypes.arrayOf(AuthTypePropType).isRequired,
  legacyScopes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired
};

const select = (state, ownProps) => ({
  hasScopeSplitAccess: getHasScopeSplitAccess(),
  hasSplitScopesInSpec: getHasSplitScopesInSpec(state, ownProps),
  granularScopes: getGranularScopes(state, ownProps),
  legacyScopes: getLegacyScopes(state, ownProps),
  securityTypes: getSecurityTypes(state, ownProps).sort().reverse()
});

export default connect(select)(Requirements);